// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Oaqrg","textarea":"styles_textarea__35bQk"};